import React from 'react';
import {
    ArrayField,
    Datagrid,
    FormDataConsumer,
    FormTab,
    ReferenceField,
    ReferenceInput,
    required,
    SimpleFormIterator,
    TextField,
    Button
} from 'react-admin';
import { Typography, Box } from '@mui/material';
import { HECOSCodesInput, TitleLengthCheck, validDatesValidation } from '../../lib/CommonComponents';
import { ArrayInput, AutocompleteInput, DateInput, TextInput } from '../../lib/wrappers/Inputs';
import { SwitchLanguageButton } from "../../lib/LanguageLink";
import { StaffInput } from '../Common/StaffInput';


var titleStyle = { color: "#AE223F" }


export const AssociateCourseInformationInputs = ({courseType, ...props}) => {
    return (
        <FormTab label="Course Information" {...props}>
            <Box display="flex" width={1} sx={{ height: '40px', borderBottom: '1px solid #AE223F', marginBottom: '15px' }} >
                <Box flex={5}>
                    <Typography variant="h6" style={titleStyle}>
                        <FormDataConsumer>
                        {({ formData, ...rest }) => formData.id ? (

                            <TitleRender courseId={formData.id} />

                        ) : null
                        }
                        </FormDataConsumer>
                        <small><TextField source="id" label={false} /></small>
                    </Typography>
                </Box>
                <Box flex={1}>
                    <SwitchLanguageButton />
                </Box>
            </Box>
            <Box width={1}>
                <Box display="flex">
                    <TextInput source="Title" validate={[required(), TitleLengthCheck]} />
                    <TextInput
                        source="certificateTitle"
                        sx={{ flex: 1, ml: 1 }}
                    />
                    <TextInput
                        source="welshCertificateTitle"
                        sx={{ flex: 1, ml: 1 }}
                    />
                </Box>
                <Box display="flex">
                    <ReferenceInput reference="Faculty" source="facultyId">
                        <AutocompleteInput
                            optionText="description"
                            sx={{ flex: 1 }}
                        />
                    </ReferenceInput>
                    <ReferenceInput
                        reference="FacultySubGroup"
                        source="subjectId"
                    >
                        <AutocompleteInput
                            optionText="description"
                            sx={{ flex: 1, ml: 1 }}
                        />
                    </ReferenceInput>
                    <TextInput source="school" sx={{ flex: 1, ml: 1 }} />
                    <FormDataConsumer>
                        {({ formData, ...rest }) =>
                            formData.departmentId ? (
                                <ReferenceInput
                                    reference="FacultySubGroup"
                                    source="subjectId"
                                    filter={{
                                        facultygroup_id: formData.departmentId,
                                    }}
                                    {...rest}
                                >
                                    <AutocompleteInput optionText="description" />
                                </ReferenceInput>
                            ) : null
                        }
                    </FormDataConsumer>
                </Box>
                <Box display="flex">
                    <ReferenceInput
                        reference="CourseLevel"
                        source="courseLevelId"
                        fullWidth
                    >
                        <AutocompleteInput
                            optionText="description"
                            sx={{ flex: 1 }}
                        />
                    </ReferenceInput>
                    <ReferenceInput reference="Status" source="statusId">
                        <AutocompleteInput
                            optionText="Title"
                            disabled={props.create}
                            sx={{ flex: 1, ml: 1 }}
                        />
                    </ReferenceInput>
                </Box>
                <Box display="flex">
                <ArrayInput source="courseLeaders" label={false} >
                <SimpleFormIterator disableReordering fullWidth>
                    <FormDataConsumer>
                        {({ formData, getSource, scopedFormData }) => (
                            <StaffInput
                                teamName="courseLeaders"
                                formData={formData}
                                getSource={getSource}
                                scopedFormData={scopedFormData}
                            />
                        )}
                    </FormDataConsumer>
                </SimpleFormIterator>
            </ArrayInput>
                    <HECOSCodesInput {...props} />
                </Box>
                <Box>
                    <ArrayInput source="moduleInfos" label="Module Infos">
                    <SimpleFormIterator disableReordering fullWidth>
                            <ReferenceInput
                                reference={
                                    courseType === 'Research'
                                        ? 'ResearchModule'
                                        : 'Module'
                                }
                                source="moduleId"
                                label="myroot.module"
                            >
                                <AutocompleteInput
                                    optionText={(choice) =>
                                        `${choice.moduleCode} - ${choice.shortTitle}`
                                    }
                                />
                            </ReferenceInput>
                            <AutocompleteInput
                                source="type"
                                choices={[
                                    { id: 'optional', name: 'myroot.optional' },
                                    { id: 'core', name: 'myroot.core' },
                                    { id: 'specified', name: 'myroot.specified'},
                                    { id: 'authorised substitution', name: 'myroot.AuthorisedSubstitution' },
                                    { id: 'additional module', name: 'myroot.AdditionalModule' }
                                ]}
                                label="Type"
                            />
                        </SimpleFormIterator>
                    </ArrayInput>
                </Box>
                <Box display="flex">
                    <DateInput
                        source="approvedDate"
                        validate={required()}
                        
                        sx={{ flex: 1, ml: 1 }}
                    />
                    <DateInput
                        source="dateClosed"                       
                        sx={{ flex: 1, ml: 1 }}
                    />
                </Box>
                <Box display="flex">
                    <DateInput
                        source="validationFrom"
                        validate={required()}
                        sx={{ flex: 1, ml: 1 }}
                    />
                    <DateInput
                        source="validationTo"
                        validate={[required(), validDatesValidation]}
                        sx={{ flex: 1, ml: 1 }}
                    />
                </Box>
            </Box>
        </FormTab>
    );
};


const TitleRender = ({ courseId }) => {
    var code = courseId.slice(0, 4);
    if(code == "RSCR")
    {
        return "Research Course ";
    }
    else if (code == "ASCR")
    {
        return "Associate Course "
    }
    return "Course ";   
}
